<div class="page-container">
  <div *ngIf="screenWidth <= 800" class="mobile-header">
    <img alt="Logo" src="assets/images/VOTeasy.png">
    <img alt="Hand" src="assets/images/mobile-logo.svg">
  </div>
  <div class="form-container d-flex flex-column justify-content-center align-items-center">
    <div class="inner-container d-flex row justify-content-center align-items-center">
      <img *ngIf="screenWidth > 800" alt="Logo" class="mb-5" src="assets/images/VOTeasy.png">
      <!--<app-login-form (errorText)="setError($event)" #loginForm ></app-login-form>-->
      <div class="d-flex justify-content-center align-items-center">
        <a href="https://student.upt.ro/" target="_blank">
          <app-button class="mx-2" label="Log in" type="blue-filled" textType="log-in" id="Log_in"
                      [loading]="loading"
          >
          </app-button>
        </a>
      </div>
      <!--<div [hidden]="loginForm.loginForm.untouched" class="error-container"
           [class.error-fade-out]="errorText === true" [class.error-fade-in]="errorText !== true">
        <div class="error d-flex align-items-center">
          <mat-icon>error_outline</mat-icon>
          <p>{{errorText}}</p>
        </div>
      </div>-->
      <div class="d-flex justify-content-center align-items-center buttons-container">
        <!--<a target="_blank"
           href="https://vote.ligaac.ro/upload/Ghid%20Aplica%C8%9Bie%20vot%20-%2025.01.2022_fdef9a3a4c.pdf"
        >
          <app-button label="How to?" type="blue" textType="normal"></app-button>
        </a>-->
        <a target="_blank" href="https://drive.google.com/drive/folders/1-nttnnUdHnI2g_ZS6dVKHV4emMi1M9N6?usp=sharing">
          <app-button class="mx-3" label="Candidați" type="blue" textType="normal"></app-button>
        </a>
      </div>
    </div>
  </div>
  <div *ngIf="screenWidth > 800" class="images-container d-flex flex-row justify-content-start align-items-center">
    <img alt="First Image" class="first-img" src="assets/images/desktop-login1.png">
    <img alt="Second Image" class="second-img" src="assets/images/desktop-login2.png">
    <img alt="Third Image" class="third-img" src="assets/images/desktop-login3.png">
  </div>
</div>
